export const collection = {
  list: (list) => list && list.constructor === Object ? [list] : list,
  max: (list) => Math.max(...list),
  isEmpty(obj) {
    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        return false
      }
    }
    return true
  }
}



// WEBPACK FOOTER //
// ./src/core/utils/collection.js